import useScrollReveal from '@/hooks/useScrollReveal';

const ScrollReveal = ({ 
  children, 
  animation = 'fade-up',
  delay = 0,
  duration = 600,
  className = '',
  stagger = false,
  staggerDelay = 120
}) => {
  const [ref, isVisible] = useScrollReveal();
  
  const animations = {
    'fade-up': { 
      from: 'opacity-0 translate-y-8', 
      to: 'opacity-100 translate-y-0' 
    },
    'fade-in': { 
      from: 'opacity-0', 
      to: 'opacity-100' 
    },
    'slide-left': { 
      from: 'opacity-0 translate-x-8', 
      to: 'opacity-100 translate-x-0' 
    },
    'slide-right': { 
      from: 'opacity-0 -translate-x-8', 
      to: 'opacity-100 translate-x-0' 
    },
    'scale': { 
      from: 'opacity-0 scale-95', 
      to: 'opacity-100 scale-100' 
    }
  };
  
  const anim = animations[animation] || animations['fade-up'];
  
  return (
    <div
      ref={ref}
      className={`transition-all ${className} ${isVisible ? anim.to : anim.from}`}
      style={{ 
        transitionDuration: `${duration}ms`,
        transitionDelay: `${delay}ms`,
        transitionTimingFunction: 'cubic-bezier(0.16, 1, 0.3, 1)'
      }}
      data-testid="scroll-reveal"
    >
      {children}
    </div>
  );
};

export default ScrollReveal;
